module.exports = __webpack_public_path__ + "img/inspiration-2.6608718.jpg";